module.exports = __webpack_public_path__ + "media/images/basic_logos/setting_kds-70b53f2fc05bc2f80706b388a2aa7491.svg";